export default {
    namespaced: true,
    state: {
        gasStationList: [],
        test: "Nguyen Duc Hung"
    },
    getters: {
        gasStationList: state => state.gasStationList,
    },
    actions: {
        async getGasStation({commit }) {
            const rs = await fetch(`${process.env.VUE_APP_API_BASE_URL}/gas-stations`);
            const data =  await rs.json();
            commit('setGasStationList', await data.data);
        },
    },
    mutations: {
        setGasStationList(state, data) {
            state.gasStationList = data;
        },
    }
}
